module.exports = __webpack_public_path__ + "static/media/ace-exibition.07c69676.jpeg";